import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

/**
 * Pipe for extracting multilanguageparts from a text
 * ONLY USABLE WITH async pipe
 *
 * @example "textkey" | twingletranslate | async
 *
 */
@Pipe({name: 'twingletranslate'})
export class TwingleTranslationPipe implements PipeTransform {

    /**
     * constructor
     * @param translate
     */
    constructor(private translate: TranslateService) {}

    /**
     * extract the multilanguage part from a text
     * @param textkey
     * @param parameter
     * @returns {any}
     */
    transform(textkey: string, parameter: any = null): any {
        if (!textkey) {
            return textkey;
        }

        // extract teh multilanguage part from the text
        let text = this.extractMultiLanguageText(textkey);
        return new Promise((resolve, reject) => {
            resolve(text);
        });
    }

    /**
     * Extract multi-languge texts from the packend and returns the text in the current user language
     * @param text
     * @returns {any}
     */
    private extractMultiLanguageText(text: string): string {
        try {
            let texts = JSON.parse(text);
            let currentLanguage = this.translate.currentLang;
            if(currentLanguage == null) {
                // Fallback to DE if we cannot determine the browsers language
                currentLanguage = "de";
            }

            if(texts[currentLanguage]) {
                // text in the current language found
                return texts[currentLanguage];
            }
            else {
                // fallback to "en" if text was not found
                return texts["en"]? texts["en"] : texts;
            }

        }
        catch (e) {
            // is no JSON String, return the whole text
            return text;
        }
    }
}